import { ReactNode, PropsWithChildren, FormEvent } from "react"
import { BaseComponent, BaseProps, BaseState } from "../BaseComponent"

interface RadioProps extends BaseProps {
    checked: boolean
    disabled?: boolean
    className?: 'form-check-input',
    labelClassName?: 'form-check-label',
    callback: Function | undefined
}

interface RadioStatus extends BaseState {
}

const defaults : RadioProps = {
    id: undefined,
    checked: false,
    disabled: false,
    className : 'form-check-input',
    labelClassName: 'form-check-label',
    callback: undefined,
    children: undefined // evita dangerouslysetinnerhtml sul <input>
}

class Radio extends BaseComponent<PropsWithChildren<RadioProps>, RadioStatus> {

    constructor (props: any) {
        super(props)

        this.mergedProps = { ...defaults, ...props} as RadioProps
        
        this.onChange = this.onChange.bind(this)
    }

    render(): ReactNode {
        const errorTag = this.getError()

        const inputClassString = (this.props.className ?? '') + ' form-check-input'
            + (this.props.checked ? ' active' : '') 
        const labelClassString = (this.props.labelClassName ?? '') + ' form-check-label' 
            + (errorTag ? ' is-invalid' : '')

        const attributes = this.getPropertyDifferences (this.mergedProps ?? {}, defaults)

        return (
            this.props.id &&
            <>
                <input 
                    id={this.props.id}
                    type="radio" 
                    className={inputClassString}
                    autoComplete="off"
                    name={this.props.name}
                    checked={this.props.checked ?? false}
                    disabled={ this.props.disabled }
                    // riporto gli eventi a cui sono intressato
                    onChange={this.onChange}
                    // stampo tutte le altre props
                    {...attributes} 
                />
                <label 
                    className={labelClassString} 
                    htmlFor={`${this.mergedProps?.id}`}
                >
                    {this.props.children}
                </label>
                {errorTag !== undefined && errorTag}
            </>
        )
    }

    private onChange (e: FormEvent<HTMLInputElement>) {
        e.preventDefault()

        if (this.props.callback) {
            this.props.callback (e.currentTarget.value)
        }
    }
}

export default Radio 